import React from 'react';
import {
  Box,
  HStack,
  VStack,
  Text,
  Icon,
  SimpleGrid,
  useBreakpointValue,
} from '@chakra-ui/react';
import { MdVerifiedUser, MdCode, MdHeadset, MdDownload, MdCheckCircle } from 'react-icons/md';

const iconMap = {
  award: MdCheckCircle,
  code: MdCode,
  headset: MdHeadset,
  download: MdDownload,
  verified: MdVerifiedUser,
};

/**
 * Trust Badges Component
 * Displays trust indicators and credibility badges
 */
const TrustBadges = ({ badges }) => {
  const gridCols = useBreakpointValue({ base: 2, md: 4 });

  if (!badges || badges.length === 0) return null;

  return (
    <SimpleGrid columns={gridCols} spacing={4} my={8}>
      {badges.map((badge, idx) => {
        const BadgeIcon = iconMap[badge.icon] || MdCheckCircle;

        return (
          <VStack key={idx} align="center" spacing={2} p={4} bg="gray.50" borderRadius="lg">
            <Icon as={BadgeIcon} w={6} h={6} color="purple.600" />
            <Text
              fontWeight="bold"
              fontSize="sm"
              textAlign="center"
              color="gray.800"
            >
              {badge.name}
            </Text>
          </VStack>
        );
      })}
    </SimpleGrid>
  );
};

export default TrustBadges;
